// const MODULES = [
//   { id: "breach", label: "Breach Intelligence" },      // Breach & Threat Intelligence
//   { id: "dns", label: "DNS" },                         // Domain & DNS Configuration
//   { id: "email", label: "Email Security" },            // SPF, DMARC, MX
//   { id: "ssl", label: "SSL / TLS" },                   // HTTPS, TLS, HSTS
//   { id: "headers", label: "Security Headers" },       // HTTP security headers
//   { id: "infra", label: "Infrastructure" },           // CDN & Hosting
//   { id: "typosquatting", label: "Typosquatting Analysis" } // Typosquatting Analysis
// ];

const MODULES = [
  {
    id: "security",
    label: "Security",
    description: "Breach intelligence, DNS configuration, SSL/TLS, and HTTP security controls.",
    modules: [
      { id: "breach", label: "Breach Intelligence" },
      { id: "dns", label: "DNS" },
      { id: "ssl", label: "SSL / TLS" },
      { id: "headers", label: "Security Headers" },
    ],
  },
  {
    id: "exposure",
    label: "Exposure",
    description: "Identifies exposed email addresses, personal information, and executive-related data.",
    modules: [
      { id: "email", label: "Email Security" },
      { id: "personalExposure", label: "Personal Exposure" },
      { id: "executiveExposure", label: "Executive Exposure" },
    ],
  },
  {
    id: "infrastructure",
    label: "Infrastructure",
    description: "Analyzes hosting infrastructure, CDN configuration, and the organization's external attack surface.",
    modules: [
      { id: "infra", label: "Infrastructure" },
      { id: "attackSurface", label: "Attack Surface" },
    ],
  },
  {
    id: "brand",
    label: "Brand Protection",
    description: "Detects domains and online assets that may impersonate or target the organization's brand.",
    modules: [
      { id: "typosquatting", label: "Typosquatting Analysis" },
    ],
  },
  {
    id: "publicIp",
    label: "Public IP Security",
    description: "Assesses public IP addresses for exposed services, insecure configurations, and known security risks.",
    modules: [
      { id: "ipDiscovery", label: "Public IP Discovery" },
      { id: "portExposure", label: "Port Exposure" },
      { id: "serviceDetection", label: "Service Detection" },
      { id: "tlsServices", label: "TLS Service Security" },
      { id: "knownVulnerabilities", label: "Known Vulnerabilities" },
    ],
  },
];

export default MODULES